import $ from 'jquery';
import page from '../../../smartpak/page';
import { tooltipProxy as tooltip } from '../../../smartpak/tooltipproxy';
import waitForElement from '../../../dom/waitforelement';

export default function handleSelectedProduct(){
    tooltip($('#addSupplyForm .tooltipTrigger'), {
        content: $('.asCopy:first').html()
    });
    waitForElement('.hasNoAddOnItems', function() {
        page.resolveLazyLoadedImages('.hasNoAddOnItems');
    });
    waitForElement('.hasAddOnItems', function() {
        page.resolveLazyLoadedImages('.hasAddOnItems');
    });
}